<template>
  <div class="shuoming">
    <div class="shuomingtxt">
      <h2>产品方案</h2>
      <p style="margin-top: 10px">
        每一个来到期货市场的个人客户，都会面对“决策难”的困境，希望有老师的指导和买卖的提示，因为这样可以降低他们的学习成本和试错成本。而期货公司有庞大的客户群体、专业的投研团队，使得其有充当该角色的天然优势。
      </p>
      <p>
        基于此，文华立足于成熟的量化交易技术和丰富的金融软件开发经验，推出文华ICS智能投顾系统，提供便捷、智能的策略研发、策略管理环境，助力期货公司把量化投研成果转化为产品服务。用户使用端以丰富的图表，多维度向客户展示策略的绩效情况，客户可根据自己的交易习惯、风险偏好，选择策略进行订阅。
      </p>
      <h3>技术架构</h3>
      <img src="../assets/img/tgsm1.png" alt="" />
      <p>文华ICS智能投顾系统由管理端和用户使用端构成。</p>
      <p>
        管理端分为用户管理、策略研发、策略管理三部分。交易管理人员通过用户管理系统可以开设账号、分配权限；策略研发人员通过策略研发系统编写策略，进行策略回测，将研发好的策略上传到云端策略列表中；策略管理人员通过策略管理端，可将云端策略列表里的策略发布/停止发布，对用户的订阅情况进行管理。
      </p>
      <p>
        个人客户可通过用户使用端浏览策略、订阅策略，客户订阅的策略在云环境中运行。
      </p>
      <h4>系统部署</h4>
      <p style="text-indent: 0; padding-left: 2em">
        为满足行情、交易数据传输，策略任务运行需求，建议至少部署3台服务器。<br />
        服务器配置要求：<br />
        <strong>• </strong>Linux操作系统；<br />
        <strong>• </strong>内存>=32G；<br />
        <strong>• </strong>CPU>=20核；<br />
        <strong>• </strong>硬盘>=500G。
      </p>
      <h3>用户管理端</h3>
      <p>
        管理人员可通过用户管理端开设账号，给策略研发人员、策略管理人员分配策略编写和策略管理的权限；给个人客户的交易账号分配权限，用户使用交易账号登录用户使用端即可浏览、订阅策略。
      </p>
      <img src="../assets/img/tgsm2.png" alt="" />
      <h3>策略研发端</h3>
      <p>
        策略研发人员可通过策略编写端编写、回测交易策略，并支持将研发好的策略上传到策略管理端中。
      </p>
      <h4>●策略编写</h4>
      <p>
        策略编写使用宽语言，采用类C语言的语法和运行逻辑，可实现各类复杂逻辑的策略开发。
      </p>
      <img src="../assets/img/tgsm3.png" alt="" />
      <h4>●策略回测</h4>
      <p>提供详细的回测报告和图表分析功能，多维度对策略进行评价。</p>
      <img src="../assets/img/tgsm4.png" alt="" />
      <h3>策略管理端</h3>
      <p>
        策略管理人员通过策略管理端查看策略研发人员上传的策略，发布/停止发布策略，并可通过订阅管理模块查看客户的订阅情况，对客户订阅进行管理。
      </p>
      <h4>●策略列表</h4>
      <p>
        策略列表可查看策略研发人员上传的策略。策略管理人员可查看策略回测报告，并支持发布/删除某个策略。
      </p>
      <img src="../assets/img/tgsm5.png" alt="" />
      <h4>●策略管理</h4>
      <p>
        策略管理模块可查看所有已发布的策略，策略管理人员可发布/停止发布某个策略，也可根据运行情况，修改策略的单份资金和最大订阅份数，并可查看某个策略对应的用户订阅情况。已发布的策略会在用户使用端进行展示，策略在云端运行。
      </p>
      <img src="../assets/img/tgsm6.png" alt="" />
      <h4>●订阅信息</h4>
      <p>
        订阅信息模块展示所有已被订阅策略的运行情况，策略管理人员可以查看每一个策略的交易明细和运行日志，并可对订阅进行持仓同步等处理。
      </p>
      <img src="../assets/img/tgsm7.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.shuoming {
  background: url("../assets/img/gn-bg.jpg") no-repeat bottom, #eff3fc;
  text-align: left;
  color: #656565;
}
.shuomingtxt {
  width: 1045px;
  padding: 40px 15px 45px 15px;

  margin: 0 auto;
}
.shuoming h2 {
  border-bottom: 1px solid #acacac;
  color: #113f8a;
  font-size: 20px;
  line-height: 60px;
  font-weight: bold;
  margin-top: 10px;
}
.shuoming h3 {
  border-left: 4px solid #02306e;
  padding-left: 4px;
  background: #e1e8f2;
  font-size: 17px;
  margin: 10px 0;
  font-weight: bold;
  line-height: 34px;
  height: 34px;
  margin-top: 20px;
}
.shuoming h4 {
  font-size: 15px;
  margin: 5px 0;
  font-weight: bold;
  margin-top: 20px;
}
.shuoming p {
  line-height: 23px;
  font-size: 14px;
  padding: 5px 0;
  text-indent: 2em;
}
.shuoming img {
  margin: 5px 0;
}
.shuoming p strong {
  font-size: 10px;
  font-weight: normal;
}
</style>